import { TextField, Select } from '@cinesend/ui-kit'
import React, { useEffect, useState } from 'react'
import useStore from '../../hooks/use_store'

const ValidatorParams = ({ name, data, fieldId, refreshData }) => {
  const [value, setValue] = useState(() => {
    try {
      return typeof data.parameters.value === 'string' ? JSON.parse(data.parameters.value) : data.parameters.value
    } catch {
      return data.parameters.value
    }
  })

  const { createModel } = useStore()

  useEffect(() => {
    try {
      const parsedValue =
        typeof data.parameters?.value === 'string' ? JSON.parse(data.parameters.value) : data.parameters.value
      setValue(parsedValue)
    } catch {
      setValue(data.parameters?.value)
    }
  }, [data.parameters?.value])

  const saveParamsValue = (val) => {
    const valueToSave = typeof val === 'object' ? JSON.stringify(val) : val

    createModel.mutate(
      {
        endpoint: 'validator-fields',
        data: {
          validator_id: data.id,
          field_id: fieldId,
          severity: data.severity,
          enabled: data.active,
          parameters: {
            options: data.parameters.options,
            value: valueToSave,
          },
        },
      },
      {
        onSuccess: refreshData,
      }
    )
  }

  const isSingleValue = typeof value === 'string' || typeof value === 'number'

  // for list return dropdown
  if (data.parameters.options) {
    return (
      <Select
        fullWidth
        label={name}
        hideLabel
        options={data.parameters.options.map((item) => ({ ...item, value: String(item.value) }))}
        value={value == null ? null : String(value)}
        onValueChange={(selected) => {
          const { value: optionValue } = data.parameters.options.find((item) => String(item.value) === selected)
          setValue(optionValue)
          saveParamsValue(optionValue)
        }}
      />
    )
  }

  return isSingleValue ? (
    <TextField
      name={name}
      label={name}
      hideLabel
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => saveParamsValue(value)}
    />
  ) : (
    <div className='flex flex-wrap gap-2'>
      {Object.entries(value).map(([key, val]) => (
        <TextField
          key={key}
          label={key.charAt(0).toUpperCase() + key.slice(1)}
          value={val}
          onChange={(e) => setValue({ ...value, [key]: e.target.value })}
          onBlur={(e) => saveParamsValue({ ...value, [key]: e.target.value })}
        />
      ))}
    </div>
  )
}

export default ValidatorParams
